module.exports = __webpack_public_path__ + "static/mantis-hub-f10fdc49ae08cf53925784699ef14a06.png";